import React from 'react'

import ReferralIntroducedTo from '@/components/misc/ReferralIntroducedTo'
import { ReferralLinkCollectionItem } from '@/types/responses/referral-links'

interface Props {
  referralLink: ReferralLinkCollectionItem
}

const IntroduceTo: React.FC<Props> = ({ referralLink }) => {
  const toCompanyName = referralLink.toCompany.presentationName

  // Nylas round-robin referral links
  if (referralLink.isCompanySchedulerLink) {
    return toCompanyName
  }

  // Calendly referral links
  if (referralLink.hasCalendlyScheduler) {
    return (
      <>
        {toCompanyName}
        <div className="text-dim text-xs">(Calendly)</div>
      </>
    )
  }

  // Nylas individual or multi-individual links
  return (
    <ReferralIntroducedTo
      users={referralLink.users}
      toCompany={referralLink.toCompany}
    />
  )
}

export default IntroduceTo
